import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';

import {styles} from './Loading.style';

// Define the interface for the component props
interface LoadingProps {}

export const Loading: React.FC<LoadingProps> = () => (
  <View style={styles.header}>
    <LoadingBox style={styles.avatar} />
    <View style={styles.headerText}>
      <View style={styles.nameContainer}>
        <LoadingBox style={styles.firstName} />
        <LoadingBox style={styles.lastName} />
      </View>
      <LoadingBox style={styles.rankDescription} />
      <View style={styles.progress}>
        <LoadingBox style={styles.progressBar} />
        <LoadingBox style={styles.progressBarPercent} />
      </View>
    </View>
  </View>
);

export default Loading;
